// extracted by mini-css-extract-plugin
export default {"advertDetailInfoDescription":"c-h_eZ"};